export { default } from './DestacatTendenciesClimatiques';
